<template>
    <a-row :gutter="24">
      <a-col :md="24">
        <a-card :style="cardStyle1" :bordered="false">
          <!-- 查询区域 -->
          <div class="table-page-search-wrapper">
            <!-- 搜索区域 -->
            <a-form layout="inline" @keyup.enter.native="searchQuery">
              <a-row :gutter="24">
                <a-col :md="8" :lg="6"  :sm="24">
                <a-form-item label="单据编号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input placeholder="请输入单据编号" v-model="topQueryParam.code"></a-input>
                </a-form-item>
              </a-col>

                <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                  <a-col :md="8" :lg="6"  :sm="24">
                    <a-button type="primary" @click="searchQuery">查询</a-button>
                    <a-button style="margin-left: 8px" @click="searchReset">重置</a-button>

                  </a-col>
                </span>

              </a-row>

            </a-form>
          </div>
          <!-- 操作按钮区域 -->
          <div class="table-operator" style="margin-top: 5px">
            <a-button @click="handleAdd" type="primary" icon="plus">添加</a-button>
          </div>
          <!-- table区域-begin -->
          <div>
            <a-table ref="table" size="middle" bordered
            :rowKey="(record,index)=>{return index}" :columns="columns"
            :dataSource="dataSource"
            :components="handleDrag(columns)"
            :pagination="ipagination"
             :scroll="{ x: true }"
            :loading="loading"
            :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange,columnWidth:'50px'}"
             @change="handleTableChange">
              <span slot="action" slot-scope="text, record">
                <a-popconfirm title="是否通过审批?" ok-text="通过" cancel-text="不通过" @confirm="() => handleAudit(record,1)" @cancel="() => handleAuditCancel(record,2)">
                  <a v-if="record.state === 1 || record.state === 2" disabled type="primary">审批</a>
                  <a v-else type="primary">审批</a>
                </a-popconfirm>
                <a-divider type="vertical" />
                <a type="primary" @click="delConfirm(handleDelete,record)">删除</a>
              </span>
              <template slot="createTime" slot-scope="createTime">
                <span>{{changetime(createTime)}}</span>
              </template>
              <template slot="state" slot-scope="state">
                <a-tag color="blue" v-if="state === 0">审核中</a-tag>
                <a-tag color="green" v-else-if="state === 1">审核通过</a-tag>
                <a-tag color="red" v-else-if="state === 2">未通过审核</a-tag>
              </template>

              <template slot="attachment" slot-scope="attachment">
                <a-popover placement="right" trigger="click">
                  <template slot="content">
                    <img :src="getImgUrl(attachment, '')" width="500px" />
                  </template>
                  <div style="width:52px;height:52px;" v-if="attachment">
                    <img  :src="getImgUrl(attachment, '')" class="item-img" title="查看大图" style="width:100%;height:auto"/>
                  </div>
                </a-popover>
              </template>

            </a-table>
          </div>
          <!-- table区域-end -->
          <!-- 表单区域 -->
          <recallModal ref="modalForm" @ok="modalFormOk" @close="modalFormClose"></recallModal>
        </a-card>
      </a-col>
    </a-row>
  </template>
  <!-- create ji sheng hua-->
  <script>
  import recallModal from './modules/recallModal'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import { BillListMixin } from './mixins/BillListMixin'
  import { recallDelete,recallEdit } from '@/api/api'
  import JEllipsis from '@/components/jeecg/JEllipsis'
  import JDate from '@/components/jeecg/JDate'
  import { getFileAccessHttpUrl } from '@api/manage'


  export default {
    name: 'RetailOutList',
    mixins: [JeecgListMixin, BillListMixin],
    components: {
      recallModal,
      JEllipsis,
      JDate,
    },
    data() {
      return {
        // scroll: '1300px',
        ipagination: {
          pageSizeOptions: ['10', '20', '30', '100', '200'],
        },
        // 查询条件
        topQueryParam: {
          page: 1,
          limit: 20,
          keywords: '',
          specification: '',
          codeSystem:''
        },
        prefixNo: 'LSCK',
        labelCol: {
          span: 5,
        },
        wrapperCol: {
          span: 18,
          offset: 1,
        },
        specList: [
          {
            // 包装规格
            label: 'A公司',
            value: '0',
          },
          {
            label: 'B公司',
            value: '1',
          }
        ],
        matype: [
          {
            label: '待审核',
            value: '1',
          },
          {
            label: '审核通过',
            value: '2',
          }
        ], // 包装规格
        // 默认列
        columns: [
          { title: '单据编号', dataIndex: 'code', width: 80,render: (text) => text || "--"},
          { title: '召回日期', dataIndex: 'recallDate', width: 120,render: (text) => text || "--"},//scopedSlots: { customRender: 'specCodeSystem' }
          { title: '商品编码', dataIndex: 'productCode', width: 120,render: (text) => text || "--"}, // ellipsis: true
          { title: '商品名称', dataIndex: 'productName', width: 200,render: (text) => text || "--"},
          { title: '应召回数量', dataIndex: 'recallNum', width: 120,render: (text) => text || "--"},
          { title: '召回人', dataIndex: 'recaller', width: 100,render: (text) => text || "--" },
          { title: '召回事由', dataIndex: 'recallReason', width: 200,render: (text) => text || "--" },
          { title: '规格型号', dataIndex: 'model', width: 120,render: (text) => text || "--" },
          { title: '计价单位', dataIndex: 'pricingUnit', width: 50,render: (text) => text || "--" },
          { title: '剂型/分类', dataIndex: 'categorize', width: 100,render: (text) => text || "--" },
          { title: '注册/备案凭证号', dataIndex: 'certificate', width: 150,render: (text) => text || "--" },
          { title: '注册/备案证有效期至', dataIndex: 'validTo', width: 150,render: (text) => text || "--" },
          { title: '生产许可证号', dataIndex: 'productionLicense', width: 150,render: (text) => text || "--" },
          { title: '生产许可证有效期至', dataIndex: 'manufacturingPermit', width: 150,render: (text) => text || "--" },
          { title: '差额原因', dataIndex: 'difference', width: 150,render: (text) => text || "--" },
          { title: '生产批号', dataIndex: 'batchNum', width: 150,render: (text) => text || "--" },
          { title: '效期', dataIndex: 'expireDate', width: 150,render: (text) => text || "--" },
          { title: '序列号', dataIndex: 'serial', width: 150,render: (text) => text || "--" },
          { title: '灭菌批号', dataIndex: 'lotNumber', width: 150,render: (text) => text || "--" },
          { title: '灭菌有效期至', dataIndex: 'sterilizationExpiration', width: 150,render: (text) => text || "--" },
          { title: '厂家物料编码', dataIndex: 'materialCode', width: 150,render: (text) => text || "--" },
          { title: '生产企业名称', dataIndex: 'factory', width: 200,render: (text) => text || "--" },
          { title: '附件', dataIndex: 'attachment', scopedSlots: { customRender: 'attachment' },width: 200,render: (text) => text || "--" },
          { title: '单据状态', dataIndex: 'state', width: 100, scopedSlots: { customRender: 'state' },render: (text) => text || "--",fixed: 'right' },
          {
            title: '操作',
            dataIndex: 'action',
            align: 'center',
            width: 180,
            fixed: 'right',
            scopedSlots: { customRender: 'action' },
          },
        ],
        url: {
          list: '/quality/recallProcess/list',
          delete: '/depotHead/delete',
          deleteBatch: '/depotHead/deleteBatch',
          batchSetStatusUrl: '/depotHead/batchSetStatus',
        },
        ul: {
          haha: '/productPi/exportPiExcelByProductId'
        }
      }
    },
    computed: {},
    created() {
      // this.initSystemConfig()
      this.initRetail()
      this.getDepotData()
      this.initUser()
      this.initAccount()
    },
    methods: {
      getImgUrl (imgName, type) {
        if (imgName && imgName.split(',')) {
          type = type ? type + '/' : ''
          return getFileAccessHttpUrl('systemConfig/static/' + type + imgName.split(',')[0])
        } else {
          return ''
        }
      },

      changetime(createTime) {
        return createTime.replace('T', ' ')
      },
      async handleAudit(record,e) {
        console.log(record,'审核record============')
        let params = {
          id : record.id,
          state: e
        }
        const res = await recallEdit(params)
        this.loadData()
      },
      //handleAuditCancel
      async handleAuditCancel(record,e) {
        console.log(record,'审核record============')
        let params = {
          id : record.id,
          state: e
        }
        const res = await recallEdit(params)
        this.loadData()
      },

      //删除handleDelete
      async handleDelete(record) {
        let params = {
          id : record.id
        }
        const res = await recallDelete(params)
        if (res.code == 200 && res.success == true) {
          this.$message.success(res.result)
          this.loadData()
        } else {
          this.$message.error(res.result)
        }

      },
    },
  }
  </script>
  <style scoped>
  @import '~@assets/less/common.less';
  /deep/.ant-table-row-cell-break-word:empty:after {
    content: '--';
  }
  </style>